import React from 'react';
import { Icons } from '../../components/atoms/SVG';
import { WidgetType } from '../../types/api/ElementType';
import { ContextWidget } from '../../types/api/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { LatestForumPostsBlock } from '../../_blocks/LatestForumPosts/LatestForumPostsBlock';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type LatestForumPostsWidget = ContextWidget<LatestForumPostsBlock, WidgetType.latestforumposts>;

export function LatestForumPostsWidget(props: LatestForumPostsWidget) {
  const { t } = useSonTranslation('LatestForumPosts');
  return <DefaultContextWidget icon={Icons.FORUM} title={t('widget.headline')} {...props} />;
}
